import React from 'react';

import s from './NotFound.module.scss';
/**
 * A simple not found component when a user navigates to a page that does not exist.
 *
 * Simply renders an image and a "Not found" text
 */
export const NotFound = (): JSX.Element => {
  return (
    <div className={s.image}>
      <div className={s.image__notfoundtext}>
        <p className={s.image__announce}>
          Síðan sem þú ert að leita að finnst ekki.
        </p>
      </div>
    </div>
  );
};
